let ymapsPromise: Promise<YMaps.IYMaps>;

export function loadYmapsApi(options: YMaps.IReadyOptions): Promise<YMaps.IYMaps> {
  if (!ymapsPromise) {
    ymapsPromise = new Promise((resolve, reject) => {
      if (window.ymaps) {
        resolve(window.ymaps);

        return;
      }

      const e = window.document.createElement('script');
      // tslint:disable-next-line
      e.src =
        'https://enterprise.api-maps.yandex.ru/2.1/?apikey=ad7bd5e9-cdc2-47b7-8455-8d4800185ea7&lang=ru-RU&load=package.system&coordorder=longlat';
      e.async = true;
      e.defer = true;
      e.onload = () => {
        resolve(window.ymaps);
      };
      e.onerror = () => {
        reject(new Error('Unable to load Yandex Maps API'));
      };
      window.document.body.appendChild(e);
    });
  }

  return ymapsPromise.then(
    ymaps =>
      new Promise<YMaps.IYMaps>((resolve, reject) => {
        ymaps.ready({
          ...options,
          successCallback: () => {
            resolve(ymaps);
          },
          errorCallback: error => {
            reject(error);
          },
        });
      }),
  );
}
